import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/contact/ContactClient.tsx");
